var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".section-header");
    this.predictiveSearch = this.querySelector("predictive-search");
    this.currentScrollTop = 0;
    window.addEventListener("scroll", this.onScroll.bind(this), false);
  }
  onScroll() {
    var _a;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    this.headerRect = this.getBoundingClientRect();
    if (this.predictiveSearch && this.predictiveSearch.isOpen)
      return;
    if ((_a = window.isMobileDevice) == null ? void 0 : _a.call(window)) {
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerRect.top) {
        window.requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerRect.top) {
        window.requestAnimationFrame(this.reset.bind(this));
      }
    } else {
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerRect.bottom) {
        window.requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerRect.bottom) {
        window.requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerRect.top) {
        window.requestAnimationFrame(this.reset.bind(this));
      }
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    this.header.classList.add("shopify-section-header-sticky");
    this.header.style.top = -1 * this.headerRect.height + "px";
  }
  reveal() {
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.style.top = 0;
  }
  reset() {
    this.header.classList.remove("shopify-section-header-sticky", "animate");
    this.header.style.top = "";
  }
}
customElements.define("sticky-header", StickyHeader);
class SlidingDrawer extends HTMLElement {
  constructor() {
    super();
    this.hasScrollbar = window.innerHeight < document.documentElement.scrollHeight;
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE")
        this.close();
    });
    this.addEventListener("click", (event) => {
      if (event.target === this || event.target.closest(".sm-drawer__close"))
        this.close();
    });
  }
  open(opener) {
    clearTimeout(this.closeTimer);
    this.openedBy = opener;
    this.style.display = "block";
      const looxContainer = document.querySelector('.loox-float-toggler-container');
  if (looxContainer) {
    looxContainer.style.display = 'none';
  }
    requestAnimationFrame(() => {
      this.closeTimer = setTimeout(() => {
        const openElements = document.querySelectorAll(".sm-modal[open], .sm-drawer[open]");
        if (openElements.length) {
          const maxZIndex = [...openElements].reduce((max, element) => {
            const zIndex = parseInt(window.getComputedStyle(element).zIndex, 10) || 0;
            return Math.max(max, zIndex);
          }, 0);
          this.style.zIndex = maxZIndex + 1;
        }
        this.setAttribute("open", "");
        document.body.classList.add(this.hasScrollbar ? "no-scrollbar" : "overflow-hidden");
      }, 50);
    });
  }
  close() {
    requestAnimationFrame(() => {
      this.removeAttribute("open");
      const openedModal = document.querySelectorAll(".sm-modal[open]");
      if (!openedModal.length) {
        document.body.classList.remove(this.hasScrollbar ? "no-scrollbar" : "overflow-hidden");
      }
      document.body.dispatchEvent(new CustomEvent("drawerClosed"));
       const looxContainer = document.querySelector('.loox-float-toggler-container');
    if (looxContainer) {
      looxContainer.style.display = ''; // 使用空字符串来恢复默认显示方式
    }
      this.closeTimer = setTimeout(() => {
        this.style.display = "none";
      }, 300);
    });
  }
}
customElements.define("sliding-drawer", SlidingDrawer);
class MenuDrawer extends SlidingDrawer {
  constructor() {
    super();
    const menu = document.querySelector(`.sm-menu-drawer__menu`);
    menu == null ? void 0 : menu.addEventListener("click", this.menuClick);
  }
  menuClick({ target }) {
    const menuItem = target.closest(".sm-menu-drawer__menu-item");
    if (menuItem) {
      if (menuItem.parentNode.hasAttribute("open")) {
        menuItem.parentNode.removeAttribute("open");
      } else {
        menuItem.parentNode.setAttribute("open", "");
      }
      return;
    }
    const menuBack = target.closest(".sm-menu-drawer__menu-back");
    if (menuBack) {
      const menuPanel = menuBack.closest(`[open]`);
      menuPanel == null ? void 0 : menuPanel.removeAttribute("open");
      return;
    }
  }
}
customElements.define("menu-drawer", MenuDrawer);
class DrawerOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button)
      return;
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const drawerId = this.getAttribute("data-drawer");
      const drawer = document.querySelector(drawerId);
      drawer == null ? void 0 : drawer.open(button);
      if (drawerId === "#search-drawer") {
        setTimeout(() => {
          const input = drawer.querySelector('input[type="search"]');
          input == null ? void 0 : input.focus();
          input == null ? void 0 : input.setSelectionRange(input.value.length, input.value.length);
        }, 300);
      }
    });
  }
}

customElements.define("drawer-opener", DrawerOpener);
class DrawerCloser extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button)
      return;
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const drawerId = this.getAttribute("data-drawer");
      const drawer = document.querySelector(drawerId);
      drawer == null ? void 0 : drawer.close();
    });
  }
}
customElements.define("drawer-closer", DrawerCloser);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.hasScrollbar = window.innerHeight < document.documentElement.scrollHeight;
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE")
        this.close();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
          this.close();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this || event.target.closest(".sm-modal__close"))
          this.close();
      });
    }
  }
  connectedCallback() {
    if (this.moved)
      return;
    this.moved = true;
    document.body.appendChild(this);
  }
  open(opener) {
    clearTimeout(this.closeTimer);
    this.openedBy = opener;
    this.style.display = "block";
    requestAnimationFrame(() => {
      this.closeTimer = setTimeout(() => {
        const openElements = document.querySelectorAll(".sm-modal[open], .sm-drawer[open]");
        if (openElements.length) {
          const maxZIndex = [...openElements].reduce((max, element) => {
            const zIndex = parseInt(window.getComputedStyle(element).zIndex, 10) || 0;
            return Math.max(max, zIndex);
          }, 0);
          this.style.zIndex = maxZIndex + 1;
        }
        this.setAttribute("open", "");
        document.body.classList.add(this.hasScrollbar ? "no-scrollbar" : "overflow-hidden");
        document.body.dispatchEvent(
          new CustomEvent("modalOpened", {
            detail: { modal: this, opener }
          })
        );
      }, 50);
    });
  }
  close() {
    requestAnimationFrame(() => {
      this.removeAttribute("open");
      const openedModal = document.querySelectorAll(".sm-modal[open]");
      if (!openedModal.length) {
        document.body.classList.remove(this.hasScrollbar ? "no-scrollbar" : "overflow-hidden");
      }
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      document.body.dispatchEvent(
        new CustomEvent("modalClosedWithDetail", {
          detail: { modal: this }
        })
      );
      this.closeTimer = setTimeout(() => {
        this.style.display = "none";
      }, 300);
    });
  }
}
customElements.define("modal-dialog", ModalDialog);
window.messageBox = function(option = {}) {
  var _a, _b, _c, _d;
  const {
    title = (_a = window.generalStrings) == null ? void 0 : _a.messageBoxTitle,
    message = (_b = window.generalStrings) == null ? void 0 : _b.messageBoxMessage,
    showConfirmButton = true,
    showCancelButton = false,
    confirmText = (_c = window.generalStrings) == null ? void 0 : _c.confirm,
    cancelText = (_d = window.generalStrings) == null ? void 0 : _d.cancel,
    callback,
    opener
  } = option;
  this.callback = callback;
  const element = document.querySelector("modal-dialog.sm-message-modal") || document.createElement("modal-dialog");
  element.className = "sm-modal sm-message-modal";
  element.innerHTML = `<div class="sm-modal__wrapper text-center">
    <div class="sm-modal__content">
      <div class="sm-modal__header text-lg mb-4">${title}</div>
      <div class="sm-modal__body opacity-80 mb-8">${message}</div>
      <div class="sm-modal__footer">
        ${showConfirmButton ? `<button class="sm-button sm-button--primary block w-full" data-type="confirm">${confirmText}</button>` : ""}
        ${showCancelButton ? `<button class="sm-button sm-button--secondary block w-full mt-2" data-type="cancel">${cancelText}</button>` : ""}
      </div>
    </div>
  </div>`;
  document.body.appendChild(element);
  if (element.dataset.isBound !== "true") {
    element.addEventListener("click", (event) => {
      const button = event.target.closest("button[data-type]");
      if (button) {
        const { type } = button.dataset;
        this.callback && this.callback(type);
        element.close();
      }
    });
    element.dataset.isBound = "true";
  }
  setTimeout(() => {
    element.open(opener);
  }, 50);
};
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button)
      return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      modal == null ? void 0 : modal.open(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.handleColorOptionClick();
  }
  handleColorOptionClick() {
    const optionElements = this.querySelector(".sm-product-card__color-options");
    if (!optionElements)
      return;
    optionElements.addEventListener("click", ({ target }) => {
      var _a;
      const option = target.closest(".sm-product-card__color-options-item");
      const mediaElement = this.querySelector(".sm-card__media-img img");
      if (option && mediaElement) {
        const src = mediaElement.getAttribute("src") || "";
        const oldSrc = src.split("?")[0] || "";
        const newSrc = ((_a = option.dataset.src) == null ? void 0 : _a.split("?")[0]) || "";
        const setSrc = src.replace(oldSrc, newSrc);
        const oldSrcset = mediaElement.getAttribute("srcset") || "";
        const setSrcset = oldSrcset.replace(new RegExp(oldSrc, "g"), newSrc);
        mediaElement.setAttribute("src", setSrc);
        mediaElement.setAttribute("srcset", setSrcset);
      }
    });
  }
}
customElements.define("product-card", ProductCard);
class SplideCarousel extends HTMLElement {
  constructor() {
    super();
    if (window.Splide && typeof window.Splide === "function") {
      this.init();
      this.splide && this.setupEventListeners();
    }
  }
  init() {
    const splide = this.querySelector(".splide");
    if (splide) {
      this.splide = new window.Splide(splide);
      this.splide.mount();
      this.setupGalleryProgress();
      const ensureSlide = this.dataset.ensureSlide;
      if (ensureSlide != null && ensureSlide !== "") {
        const idx = Number(ensureSlide);
        if (!Number.isNaN(idx)) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              var _a;
              if (((_a = this.splide) == null ? void 0 : _a.index) !== idx) {
                this.splide.go(idx);
              }
            });
          });
        }
      }
    }
  }
  setupEventListeners() {
    window.addEventListener(
      "resize",
      window.debounce(() => {
        this.refresh();
      }, 500)
    );
  }
  go(index) {
    index = Number(index);
    if (this.splide.index != index) {
      this.splide.go(index);
    }
  }
  refresh() {
    var _a;
    (_a = this.splide) == null ? void 0 : _a.refresh();
  }
  setupGalleryProgress() {
    const gallery = this.closest(".sm-media-gallery");
    if (!gallery || !this.splide) return;
    const segments = gallery.querySelectorAll("[data-gallery-progress-segment]");
    if (!segments.length) return;
    const updateProgress = () => {
      segments.forEach((segment, index) => {
        segment.classList.toggle("is-active", index === this.splide.index);
      });
    };
    this.splide.on("mounted moved", updateProgress);
    updateProgress();
  }
}
customElements.define("splide-carousel", SplideCarousel);
class SplideThumbnailCarousel extends SplideCarousel {
  constructor() {
    super();
  }
  init() {
    const splide = this.querySelector("[data-splide-carousel]");
    const thumbnails = this.querySelectorAll("[data-thumbnail-carousel]");
    if (splide && thumbnails.length) {
      this.splide = new window.Splide(splide);
      this.thumbnails = [];
      thumbnails.forEach((el) => {
        const t = new window.Splide(el);
        this.splide.sync(t);
        this.thumbnails.push(t);
      });
      this.splide.mount();
      this.thumbnails.forEach((t) => t.mount());
      this.setupGalleryProgress();
    }
  }
}
customElements.define("splide-thumbnail-carousel", SplideThumbnailCarousel);
class BackToTop extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "onBackToTop", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
    this.backToTopButton = this.querySelector(".sm-back-to-top");
    window.addEventListener("scroll", this.onScroll.bind(this), false);
    this.backToTopButton.addEventListener("click", this.onBackToTop);
  }
  onScroll() {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > 20) {
      this.backToTopButton.classList.add("show");
    } else {
      this.backToTopButton.classList.remove("show");
    }
  }
}
customElements.define("back-to-top", BackToTop);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster)
      return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e, focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus)
        deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        deferredElement.play();
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.redirectAvailable();
    }
    const currentVariant = this.currentVariant;
    this.dispatchEvent(
      new CustomEvent("variant-change", {
        bubbles: true,
        detail: {
          currentVariant
        }
      })
    );
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll(".sm-options__fieldset"), (element) => {
      var _a;
      return (_a = Array.from(element.querySelectorAll('input[type="radio"]')).find((radio) => radio.checked)) == null ? void 0 : _a.value;
    });
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        var _a;
        return ((_a = this.options) == null ? void 0 : _a[index]) === option;
      }).includes(false);
    });
  }
  getVariantData() {
    var _a;
    this.variantData = this.variantData || JSON.parse((_a = this.querySelector('[data-name="json-product-variants"][type="application/json"]')) == null ? void 0 : _a.textContent);
    return this.variantData;
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".sm-options__fieldset")];
    inputWrappers.forEach((option, index) => {
      if (index === 0)
        return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector('input[type="radio"]:checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(
        (variant) => variant[`option${index}`] === previousOptionSelected
      );
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableValuesItems = availableValuesList.filter((a) => a.options.includes(value));
      element.parentNode.classList.toggle("hidden", !availableValuesItems.length);
      const isDisabled = !availableValuesItems.length || !availableValuesItems.some((a) => a.available === true);
      element.classList.toggle("disabled", isDisabled);
    });
  }
  redirectAvailable() {
    const unavailableOption = this.querySelector(".sm-options__item.hidden :checked");
    const availableControl = unavailableOption == null ? void 0 : unavailableOption.closest(".sm-options__control");
    const availableOption = availableControl == null ? void 0 : availableControl.querySelector('input[type="radio"]:not(.disabled)');
    availableOption && availableOption.click();
  }
}
customElements.define("variant-picker", VariantPicker);
class VariantSelects extends VariantPicker {
  constructor() {
    super();
    this.updatePreSaleVariant();
  }
  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.updateVariantStatuses();
    const shouldDisable = !this.currentVariant || this.currentVariant.available !== true;
    this.toggleAddButton(shouldDisable, window.variantStrings.soldOut);
    if (!this.currentVariant) {
      this.redirectAvailable();
    } else {
      const isMobileAtcModal = (this.dataset.section || "").endsWith("-mobile-atc");
      if (!isMobileAtcModal) {
        this.updateURL();
      }
      this.updateVariantInput();
      if (!isMobileAtcModal) {
        this.updateMedia();
        this.renderProductInfo();
      }
      this.updatePreSaleVariant();
    }
  }
  updateSelectedSwatchValue({ target }) {
    var _a;
    const { value } = target;
    const { position } = target.dataset;
    const checkedElement = this.querySelector(`.sm-options__fieldset[data-position="${position}"] [data-checked]`);
    if (checkedElement) {
      if (Number(position) === 2) {
        const checkedOptionLabel = target.parentNode.querySelector("label");
        checkedElement.innerHTML = checkedOptionLabel.dataset.value;
      } else {
        checkedElement.innerHTML = (_a = window.capitalizeEachWord) == null ? void 0 : _a.call(window, value);
      }
      checkedElement.setAttribute("data-checked", value);
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false")
      return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    // 支持同一页面存在多个表单（例如：页面内表单 + 移动端弹窗表单）
    const formPrefix = `product-form-${this.dataset.section}`;
    const installmentPrefix = `product-form-installment-${this.dataset.section}`;
    const productForms = document.querySelectorAll(
      `form[id^="${formPrefix}"], form[id^="${installmentPrefix}"]`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input)
        return;
      input.value = this.currentVariant.id;
      input.disabled = !this.currentVariant.available;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  updateMedia() {
    var _a, _b, _c, _d;
    const { section } = this.dataset;
    const mediaGallery = document.querySelector(`#media-gallery-${section}`);
    if (!mediaGallery)
      return;
    const splideCarousel = (mediaGallery == null ? void 0 : mediaGallery.querySelector("splide-carousel")) || (mediaGallery == null ? void 0 : mediaGallery.querySelector("splide-thumbnail-carousel"));
    if (!splideCarousel)
      return;
    const mediaId = (_b = (_a = this.currentVariant) == null ? void 0 : _a.featured_media) == null ? void 0 : _b.id;
    const mediaEle = mediaGallery.querySelector(`[data-splide-carousel] [data-media-id="${mediaId}"]`);
    const mediaIndex = ((_c = mediaEle == null ? void 0 : mediaEle.dataset) == null ? void 0 : _c.index) || 0;
    (_d = splideCarousel.go) == null ? void 0 : _d.call(splideCarousel, mediaIndex);
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`).then((response) => response.text()).then((responseText) => {
      var _a;
      if (((_a = this.currentVariant) == null ? void 0 : _a.id) !== requestedVariantId)
        return;
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const priceSource = html.getElementById(`price-${sectionId}`);
      const priceDestination = document.getElementById(`price-${this.dataset.section}`);
      if (priceSource && priceDestination)
        priceDestination.innerHTML = priceSource.innerHTML;
      const addButtonUpdated = html.getElementById(`product-submit-button-${sectionId}`);
      const shouldDisable = addButtonUpdated
        ? addButtonUpdated.hasAttribute("disabled")
        : !this.currentVariant || this.currentVariant.available !== true;
      this.toggleAddButton(shouldDisable, window.variantStrings.soldOut);
      const saleStatusSource = html.getElementById(`product-sale-status-${sectionId}`);
      const saleStatusDestination = document.getElementById(`product-sale-status-${this.dataset.section}`);
      if (saleStatusSource && saleStatusDestination)
        saleStatusDestination.innerHTML = saleStatusSource.innerHTML;
      window.publish(window.PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId,
          html,
          variant: this.currentVariant
        }
      });
    }).catch((error) => {
      console.error("An error occurred in the function renderProductInfo", error);
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const formPrefix = `product-form-${this.dataset.section}`;
    const productForms = document.querySelectorAll(`form[id^="${formPrefix}"]`);
    const mobileOpenButtons = document.querySelectorAll(
      `product-form[data-section-id="${this.dataset.section}"] [name="open-mobile-atc"]`
    );
    mobileOpenButtons.forEach((button) => {
      const buttonText = button.querySelector(".sm-product-form__submit-text");
      if (disable) {
        button.setAttribute("disabled", "disabled");
        if (buttonText && text)
          buttonText.textContent = text;
      } else {
        button.removeAttribute("disabled");
        if (buttonText)
          buttonText.textContent = window.variantStrings.addToCart;
      }
    });
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] .sm-product-form__submit-text');
      if (!addButton)
        return;
      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text && addButtonText)
          addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        if (addButtonText)
          addButtonText.textContent = window.variantStrings.addToCart;
      }
    });
    if (!modifyClass)
      return;
  }
  updatePreSaleVariant() {
    const { presaleIds, presaleEndTime, presaleForce } = this.dataset;
    const icons = this.querySelectorAll(".sm-icon-presale");

    if (presaleForce === "true") {
      icons.forEach((icon) => icon.classList.remove("hidden"));
      return;
    }
    if (!presaleIds)
      return;
    const presaleEndTimeSec = new Date(presaleEndTime).getTime();
    const currentTimeSec = (/* @__PURE__ */ new Date()).getTime();
    if (currentTimeSec > presaleEndTimeSec) {
      const saleStatusDestination = document.getElementById(`product-sale-status-${this.dataset.section}`);
      if (saleStatusDestination)
        saleStatusDestination.setAttribute("data-status", "in-stock");
      return;
    }
    this.updateOptions();
    this.updateMasterId();
    icons.forEach((icon) => {
      icon.classList.add("hidden");
    });
    const ids = presaleIds.split(",");
    const updateOptionNode = (id, options = []) => {
      if (!id)
        return;
      for (let option of options) {
        let optionNode = this.querySelector(`input[type="radio"][value="${option}"]`);
        if (!optionNode)
          continue;
        let icon = optionNode.parentNode.querySelector(".sm-icon-presale");
        if (ids.includes(String(id))) {
          icon == null ? void 0 : icon.classList.remove("hidden");
        } else {
          icon == null ? void 0 : icon.classList.add("hidden");
        }
      }
    };
    const curOption1Arr = this.variantData.filter((v) => v.option1 === this.currentVariant.option1);
    curOption1Arr.forEach(({ id, options = [] }) => {
      updateOptionNode(id, options);
    });
    updateOptionNode(this.currentVariant.id, this.currentVariant.options);
  }
}
customElements.define("variant-selects", VariantSelects);
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "quantityUpdateUnsubscriber");
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(
      (button) => button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = window.subscribe(
      window.PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
     const finalQuantityField = document.getElementById(`final-quantity-${this.dataset.section}`);

    // 如果找到该元素，就把可见输入框的值赋给它
    if (finalQuantityField) {
        finalQuantityField.value = this.input.value;
    }
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === "plus") {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
    if (this.input.dataset.min === previousValue && event.target.name === "minus") {
      this.input.value = parseInt(this.input.min);
      // 找到你新添加的隐藏输入框，并通过它的 ID 来选择它
        const finalQuantityField = document.getElementById(`final-quantity-${this.dataset.section}`);

        // 如果找到该元素，就把可见输入框的值赋给它
        if (finalQuantityField) {
            finalQuantityField.value = this.input.value;
        }
    }
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector("button[name='minus']");
      buttonMinus.classList.toggle("disabled", parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      if (value > max)
        this.input.value = max;
      const buttonPlus = this.querySelector("button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
class CollapseElement extends HTMLElement {
  constructor() {
    super();
    const header = this.querySelector(".sm-collapse__header");
    header == null ? void 0 : header.addEventListener("click", this.onClick.bind(this));
  }
  connectedCallback() {
    this.initCollapse();
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (["childList", "subtree"].includes(mutation.type)) {
          this.initCollapse();
        }
      });
    });
    const config = {
      childList: true,
      subtree: true
    };
    observer.observe(this, config);
    window.addEventListener(
      "resize",
      window.debounce(() => {
        this.calculateHeight();
      }, 500)
    );
  }
  calculateHeight() {
    var _a;
    const content = this.querySelector(".sm-collapse__container-content");
    const contentHei = content == null ? void 0 : content.getBoundingClientRect().height;
    (_a = content == null ? void 0 : content.parentNode) == null ? void 0 : _a.style.setProperty("--collapse-container-height", contentHei + "px");
  }
  initCollapse() {
    this.calculateHeight();
    const images = this.querySelectorAll("img");
    if (images == null ? void 0 : images.length) {
      let loadedImages = 0;
      let failedImages = 0;
      const handleImageLoad = (isFailed) => {
        if (isFailed)
          failedImages++;
        else
          loadedImages++;
        if (loadedImages + failedImages === images.length) {
          this.calculateHeight();
          console.log(`All images processed: ${loadedImages} loaded, ${failedImages} failed.`);
        }
      };
      images.forEach((img) => {
        if (img.complete) {
          img.naturalWidth > 0 ? handleImageLoad(false) : handleImageLoad(true);
        } else {
          img.onload = () => handleImageLoad(false);
          img.onerror = () => handleImageLoad(true);
        }
      });
    }
  }
  onClick() {
    var _a;
    if (this.toggleAttribute) {
      this.toggleAttribute("open");
    } else {
      (_a = window.toggleAttribute) == null ? void 0 : _a.call(window, this, "open");
    }
  }
}
customElements.define("collapse-element", CollapseElement);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.handleIntersection();
  }
  handleIntersection() {
    fetch(this.dataset.url).then((response) => response.text()).then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector("product-recommendations");
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        window.publish(window.PUB_SUB_EVENTS.listRenderCompleted);
      }
    }).catch((error) => {
      console.error("An error occurred in the function handleIntersection", error);
    });
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.renderRecentlyViewedProducts();
  }
  async renderRecentlyViewedProducts() {
    const recentlyViewedProducts = JSON.parse(localStorage.getItem("__sm_recently_viewed_products")) || [];
    if (!recentlyViewedProducts.length)
      return;
    const urls = recentlyViewedProducts.map(
      (handle) => `${window.Shopify.routes.root}products/${handle}?section_id=recently-viewed-product`
    );
    const responses = await window.fetchWithConcurrencyLimit(urls, "text");
    const { layoutType } = this.dataset;
    let html = "";
    const products = [];
    responses.forEach((responseText, index) => {
      const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
      const productElement = responseHTML.querySelector(".sm-recently-viewed-product");
      const productCard = productElement == null ? void 0 : productElement.querySelector("product-card");
      if (productCard) {
        const quickAddModal = productCard.querySelector("quick-add-modal");
        if (quickAddModal) {
          quickAddModal.dataset.index = index;
        }
        if (layoutType === "grid") {
          html += `<li>${productElement.innerHTML}</li>`;
        } else {
          html += `<div class="splide__slide">${productElement.innerHTML}</div>`;
        }
        const productJsonScript = responseHTML.querySelector(
          '[data-name="json-pixel-products"][type="application/json"]'
        );
        if (productJsonScript) {
          const productJson = productJsonScript.textContent;
          const productData = JSON.parse(productJson);
          products.push(productData);
        }
      }
    });
    const jsonScript = this.querySelector('[data-name="json-pixel-products"][type="application/json"]');
    if (products.length && jsonScript) {
      jsonScript.textContent = JSON.stringify(products);
      window.publish(window.PUB_SUB_EVENTS.listRenderCompleted);
    }
    if (layoutType === "grid") {
      const gridList = this.querySelector(".sm-recently-viewed__grids-list");
      gridList && window.setInnerHTML(gridList, html);
    } else {
      const splideList = this.querySelector(".splide__list");
      splideList && window.setInnerHTML(splideList, html);
      const splideCarousel = this.querySelector("splide-carousel");
      splideCarousel == null ? void 0 : splideCarousel.refresh();
    }
    this.parentNode.classList.remove("hidden");
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);
class CountdownElement extends HTMLElement {
  constructor() {
    super();
    const startTime = new Date(this.getTimeZone());
    let endTime = null;
    if (this.dataset.timeType === "custom") {
      const [datePart, timePart] = this.dataset.endTime.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hours, minutes, seconds] = timePart.split(":").map(Number);
      endTime = new Date(year, month - 1, day, hours, minutes, seconds);
    } else {
      endTime = new Date(this.dataset.endTime);
    }
    this.setupCountdown(startTime, endTime);
    this.timer = setInterval(() => {
      this.setupCountdown(startTime, endTime);
    }, 1e3);
  }
  getTimeZone(date = /* @__PURE__ */ new Date()) {
    return Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23"
    }).format(date);
  }
  setupCountdown(startTime, endTime) {
    const currentTime = new Date(this.getTimeZone());
    const elapsedTime = currentTime - startTime;
    const totalInterval = endTime - startTime;
    let totalSeconds = Math.floor((totalInterval - elapsedTime) / 1e3);
    if (totalSeconds < 0) {
      totalSeconds = 0;
    }
    const daysTensNode = this.querySelector("[data-days-tens]");
    const daysUnitsNode = this.querySelector("[data-days-units]");
    const hoursTensNode = this.querySelector("[data-hours-tens]");
    const hoursUnitsNode = this.querySelector("[data-hours-units]");
    const minutesTensNode = this.querySelector("[data-minutes-tens]");
    const minutesUnitsNode = this.querySelector("[data-minutes-units]");
    const secondsTensNode = this.querySelector("[data-seconds-tens]");
    const secondsUnitsNode = this.querySelector("[data-seconds-units]");
    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    if (daysTensNode && daysUnitsNode) {
      days = Math.floor(totalSeconds / (3600 * 24));
      hours = Math.floor(totalSeconds % (3600 * 24) / 3600);
      minutes = Math.floor(totalSeconds % 3600 / 60);
      seconds = Math.floor(totalSeconds % 60);
    } else if (hoursTensNode && hoursUnitsNode) {
      hours = Math.floor(totalSeconds / 3600);
      minutes = Math.floor(totalSeconds % 3600 / 60);
      seconds = Math.floor(totalSeconds % 60);
    } else if (minutesTensNode && minutesUnitsNode) {
      minutes = Math.floor(totalSeconds / 60);
      seconds = Math.floor(totalSeconds % 60);
    } else if (secondsTensNode && secondsUnitsNode) {
      seconds = totalSeconds;
    }
    const daysTens = Math.floor(days / 10);
    const daysUnits = days % 10;
    const hoursTens = Math.floor(hours / 10);
    const hoursUnits = hours % 10;
    const minutesTens = Math.floor(minutes / 10);
    const minutesUnits = minutes % 10;
    const secondsTens = Math.floor(seconds / 10);
    const secondsUnits = seconds % 10;
    if (daysTensNode && daysUnitsNode) {
      daysTensNode.innerHTML = daysTens;
      daysUnitsNode.innerHTML = daysUnits;
    }
    if (hoursTensNode && hoursUnitsNode) {
      hoursTensNode.innerHTML = hoursTens;
      hoursUnitsNode.innerHTML = hoursUnits;
    }
    if (minutesTensNode && minutesUnitsNode) {
      minutesTensNode.innerHTML = minutesTens;
      minutesUnitsNode.innerHTML = minutesUnits;
    }
    if (secondsTensNode && secondsUnitsNode) {
      secondsTensNode.innerHTML = secondsTens;
      secondsUnitsNode.innerHTML = secondsUnits;
    }
    if (totalSeconds <= 0) {
      this.setAttribute("data-expired", "true");
      clearInterval(this.timer);
    }
  }
}
customElements.define("countdown-element", CountdownElement);
class TabsElement extends HTMLElement {
  constructor() {
    var _a;
    super();
    if ((_a = this.querySelectorAll(".sm-tabs-item")) == null ? void 0 : _a.length) {
      const wrapElement = this.querySelector(".sm-tabs__wrap");
      wrapElement == null ? void 0 : wrapElement.addEventListener("click", (event) => {
        const itemElement = event.target.closest(".sm-tabs-item");
        if (itemElement) {
          const index = itemElement.dataset.index;
          const itemElements = itemElement.parentNode.querySelectorAll(".sm-tabs-item");
          const contentElements = Array.from(this.querySelectorAll(".sm-tabs__content"));
          itemElements.forEach((item, index2) => {
            var _a2, _b;
            if (item === itemElement) {
              item.classList.add("active");
              (_a2 = contentElements[index2]) == null ? void 0 : _a2.classList.remove("hidden");
            } else {
              item.classList.remove("active");
              (_b = contentElements[index2]) == null ? void 0 : _b.classList.add("hidden");
            }
          });
          this.setAttribute("data-active", index);
        }
      });
    }
  }
}
customElements.define("tabs-element", TabsElement);

// Global fallback for body scroll lock.
// Some custom dialogs lock body scroll via class/style, but may fail to unlock on edge paths.
(function installBodyScrollLockGuard() {
  const hasAnyOpenOverlay = () => {
    return Boolean(
      document.querySelector(
        ".sm-modal[open], .sm-drawer[open], [class*='get-the-look-modal-'].is-open"
      )
    );
  };
  const releaseBodyScrollIfSafe = () => {
    if (hasAnyOpenOverlay())
      return;
    document.body.classList.remove("no-scrollbar", "overflow-hidden");
    if (document.body.style.overflow === "hidden") {
      document.body.style.overflow = "";
    }
  };
  const scheduleCheck = () => {
    requestAnimationFrame(releaseBodyScrollIfSafe);
  };
  document.addEventListener("DOMContentLoaded", scheduleCheck);
  window.addEventListener("pageshow", scheduleCheck);
  document.body.addEventListener("drawerClosed", scheduleCheck);
  document.body.addEventListener("modalClosed", scheduleCheck);
  document.addEventListener("click", scheduleCheck, true);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      scheduleCheck();
    }
  });
})();

// -----------------------------
// Mobile ATC modal sync helpers
// -----------------------------
window.__smMobileAtcSyncing = false;
window.getSelectedOptionValues = function(variantSelectsEl) {
  if (!variantSelectsEl)
    return [];
  const fieldsets = variantSelectsEl.querySelectorAll(".sm-options__fieldset");
  return Array.from(fieldsets).map((fs) => {
    var _a;
    return (_a = fs.querySelector('input[type="radio"]:checked')) == null ? void 0 : _a.value;
  }).filter(Boolean);
};
window.applyOptionValuesToVariantSelects = function(variantSelectsEl, values) {
  if (!variantSelectsEl || !values || !values.length)
    return;
  const fieldsets = variantSelectsEl.querySelectorAll(".sm-options__fieldset");
  values.forEach((val, idx) => {
    const fs = fieldsets[idx];
    if (!fs)
      return;
    const input = fs.querySelector(`input[type="radio"][value="${CSS.escape(val)}"]`);
    if (input && !input.checked) {
      input.click();
    }
  });
};
window.getQuantityValueFromForm = function(formEl) {
  var _a;
  const input = formEl == null ? void 0 : formEl.querySelector('input[name="quantity"]');
  const v = (_a = input == null ? void 0 : input.value) != null ? _a : "";
  const num = parseInt(v, 10);
  if (Number.isFinite(num) && num > 0)
    return String(num);
  return "";
};
window.setQuantityValueOnForm = function(formEl, quantityStr) {
  const input = formEl == null ? void 0 : formEl.querySelector('input[name="quantity"]');
  if (!input || !quantityStr)
    return;
  if (input.value === quantityStr)
    return;
  input.value = quantityStr;
  input.dispatchEvent(new Event("change", { bubbles: true }));
};
window.syncMobileAtcBetween = function(baseSectionId, direction) {
  if (!baseSectionId)
    return;
  const modalSectionId = `${baseSectionId}-mobile-atc`;
  const mainVariantSelects = document.getElementById(`variant-selects-${baseSectionId}`);
  const modalVariantSelects = document.getElementById(`variant-selects-${modalSectionId}`);
  const mainForm = document.querySelector(`form[id^="product-form-${baseSectionId}"]`);
  const modalForm = document.querySelector(`form[id^="product-form-${modalSectionId}"]`);
  if (!mainVariantSelects || !modalVariantSelects || !mainForm || !modalForm)
    return;
  const fromVariant = direction === "main-to-modal" ? mainVariantSelects : modalVariantSelects;
  const toVariant = direction === "main-to-modal" ? modalVariantSelects : mainVariantSelects;
  const fromForm = direction === "main-to-modal" ? mainForm : modalForm;
  const toForm = direction === "main-to-modal" ? modalForm : mainForm;
  const optionValues = window.getSelectedOptionValues(fromVariant);
  window.applyOptionValuesToVariantSelects(toVariant, optionValues);
  const qty = window.getQuantityValueFromForm(fromForm);
  window.setQuantityValueOnForm(toForm, qty);
};

document.body.addEventListener("modalOpened", (event) => {
  var _a;
  const modal = (_a = event.detail) == null ? void 0 : _a.modal;
  if (!(modal == null ? void 0 : modal.id) || !modal.id.startsWith("mobile-atc-"))
    return;
  const baseSectionId = modal.id.replace("mobile-atc-", "");
  if (window.__smMobileAtcSyncing)
    return;
  window.__smMobileAtcSyncing = true;
  try {
    window.syncMobileAtcBetween(baseSectionId, "main-to-modal");
  } finally {
    window.__smMobileAtcSyncing = false;
  }
});

document.addEventListener("variant-change", (event) => {
  const target = event.target;
  if (!target || target.tagName !== "VARIANT-SELECTS")
    return;
  const section = target.dataset.section || "";
  if (!section)
    return;
  if (window.__smMobileAtcSyncing)
    return;
  const isModal = section.endsWith("-mobile-atc");
  const baseSectionId = isModal ? section.replace(/-mobile-atc$/, "") : section;
  window.__smMobileAtcSyncing = true;
  try {
    window.syncMobileAtcBetween(baseSectionId, isModal ? "modal-to-main" : "main-to-modal");
  } finally {
    window.__smMobileAtcSyncing = false;
  }
});

document.addEventListener("change", (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement))
    return;
  if (input.name !== "quantity")
    return;
  const form = input.closest("form");
  if (!form || !form.id || !form.id.startsWith("product-form-"))
    return;
  if (window.__smMobileAtcSyncing)
    return;
  const match = form.id.match(/^product-form-(.+?)(?:-\d+)?$/);
  const rawSection = match ? match[1] : "";
  if (!rawSection)
    return;
  const isModal = rawSection.endsWith("-mobile-atc");
  const baseSectionId = isModal ? rawSection.replace(/-mobile-atc$/, "") : rawSection;
  window.__smMobileAtcSyncing = true;
  try {
    window.syncMobileAtcBetween(baseSectionId, isModal ? "modal-to-main" : "main-to-modal");
  } finally {
    window.__smMobileAtcSyncing = false;
  }
});
class GridToggle extends HTMLElement {
  constructor() {
    super();
    const buttonElement = this.querySelector(".sm-grid-toggle__button");
    buttonElement == null ? void 0 : buttonElement.addEventListener("click", this.onButtonClick.bind(this));
  }
  onButtonClick({ target, currentTarget }) {
    const svgElement = target.closest("svg[data-column]");
    if (svgElement && currentTarget.contains(svgElement)) {
      const column = svgElement.dataset.column;
      Array.from(svgElement.parentNode.children).forEach((child) => {
        if (child === svgElement) {
          child.classList.add("active");
        } else {
          child.classList.remove("active");
        }
      });
      const target2 = this.dataset.target;
      if (!target2)
        return;
      const targetElement = document.querySelector(target2);
      if (targetElement) {
        targetElement.dataset.colums = column;
        targetElement.style.gridTemplateColumns = `repeat(${column}, minmax(0, 1fr))`;
      }
    }
  }
}
customElements.define("grid-toggle", GridToggle);
class ImageWithPlaceholder extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const imgElement = this.querySelector("img");
    if (imgElement) {
      const handleLoaded = () => {
        this.setAttribute("data-loaded", true);
      };
      if (imgElement.complete && imgElement.naturalWidth !== 0) {
        handleLoaded();
      } else {
        imgElement.addEventListener("load", handleLoaded, { once: true });
        imgElement.addEventListener("error", handleLoaded, { once: true });
      }
    }
  }
}
customElements.define("image-with-placeholder", ImageWithPlaceholder);




document.addEventListener('DOMContentLoaded', () => {
    // 获取表单容器和相关元素
    const dropdownMenu = document.querySelector('.sm-dropdown-menu');
    const dropdownButton = dropdownMenu.querySelector('button');
    const dropdownContent = document.querySelector('.sm-dropdown-menu__content');
    
    // 获取表单和隐藏输入框
    const localizationForm = document.getElementById('localization_form');
    const languageInput = localizationForm.querySelector('input[name="language_code"]');
    const countryInput = localizationForm.querySelector('input[name="country_code"]');
    const returnToInput = localizationForm.querySelector('input[name="return_to"]');
    
    // 获取下拉列表和选中项的显示元素
    const languageSelector = dropdownContent.querySelector('.language-selector');
    const currencySelector = dropdownContent.querySelector('.currency-selector');
    const selectedLanguageContainer = dropdownContent.querySelector('.selected-language');
    const selectedCurrencyContainer = dropdownContent.querySelector('.selected-currency');

    // 下拉列表的显示/隐藏和图标旋转
    const languageHeader = dropdownContent.querySelector('.language-header');
    const languageList = dropdownContent.querySelector('#language-list');
    const languageIcon = languageHeader.querySelector('.language-toggle-icon');
    
    const currencyHeader = dropdownContent.querySelector('.currency-header');
    const currencyList = dropdownContent.querySelector('#currency-list');
    const currencyIcon = currencyHeader.querySelector('.currency-toggle-icon');

    // 初始化：隐藏语言和货币列表
    languageList.style.display = 'none';
    currencyList.style.display = 'none';

    // 获取勾选图标的模板
    const checkmarkTemplate = document.getElementById('check-icon-template');
    const checkmarkHtml = checkmarkTemplate ? checkmarkTemplate.innerHTML : '';

    /**
     * 货币到国家代码的映射表
     */
    const currencyToCountryMap = {
        'USD': 'US',
    'AUD': 'AU',
    'CAD': 'CA',
    'CHF': 'CH',
    'EUR': 'DE',
    'GBP': 'GB',
    'JPY': 'JP',
    'XAF': 'GQ',
    'ZAR': 'ZA',
    'HKD': 'HK', 
    'SGD': 'SG', 
    };

    /**
     * 更新选中状态和视觉效果
     */
    function updateSelectedState(selector, selectedContainer, clickedItem, inputElement) {
        const items = selector.querySelectorAll('li');
        items.forEach(item => {
            item.removeAttribute('data-selected');
            const checkmark = item.querySelector('.checkmark-icon');
            if (checkmark) {
                checkmark.remove();
            }
        });

        clickedItem.setAttribute('data-selected', 'true');
        const newCheckmark = document.createElement('span');
        newCheckmark.className = 'checkmark-icon';
        newCheckmark.innerHTML = checkmarkHtml;
        clickedItem.appendChild(newCheckmark);

        selectedContainer.textContent = clickedItem.querySelector('span').textContent.trim();
        
        if (selector === currencySelector) {
            const currencyCode = clickedItem.dataset.value;
            const countryCode = currencyToCountryMap[currencyCode];
            if (countryCode) {
                inputElement.value = countryCode;
            }
        } else {
            inputElement.value = clickedItem.dataset.value;
        }
    }
    
    // 初始化选择器状态（从表单默认值读取）
    function initializeSelectionFromForm() {
        const currentLanguageCode = languageInput.value;
        const languageItem = languageSelector.querySelector(`[data-value="${currentLanguageCode}"]`);
        if (languageItem) {
            updateSelectedState(languageSelector, selectedLanguageContainer, languageItem, languageInput);
        }

        const currentCountryCode = countryInput.value;
        const currencyCode = Object.keys(currencyToCountryMap).find(key => currencyToCountryMap[key] === currentCountryCode);
        const currencyItem = currencySelector.querySelector(`[data-value="${currencyCode}"]`);
        if (currencyItem) {
            updateSelectedState(currencySelector, selectedCurrencyContainer, currencyItem, countryInput);
        }
    }
    
    initializeSelectionFromForm();
    
    // 主下拉菜单的显示/隐藏逻辑
    dropdownButton.addEventListener('click', (event) => {
        event.stopPropagation();
        const isExpanded = dropdownButton.getAttribute('aria-expanded') === 'true';
        dropdownButton.setAttribute('aria-expanded', !isExpanded);
        dropdownContent.setAttribute('aria-hidden', isExpanded);
    });

    // 点击页面其他区域时隐藏下拉菜单
    document.addEventListener('click', (event) => {
        if (!dropdownMenu.contains(event.target)) {
            dropdownButton.setAttribute('aria-expanded', 'false');
            dropdownContent.setAttribute('aria-hidden', 'true');
        }
    });

    // 语言列表的展开/收起和图标旋转
    languageHeader.addEventListener('click', () => {
        const isVisible = languageList.style.display !== 'none';
        languageList.style.display = isVisible ? 'none' : 'block';
        languageIcon.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(180deg)';
    });

    // 货币列表的展开/收起和图标旋转
    currencyHeader.addEventListener('click', () => {
        const isVisible = currencyList.style.display !== 'none';
        currencyList.style.display = isVisible ? 'none' : 'block';
        currencyIcon.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(180deg)';
    });

    // 处理语言选项的选择
    languageSelector.addEventListener('click', (event) => {
        const clickedItem = event.target.closest('li');
        if (clickedItem) {
            updateSelectedState(languageSelector, selectedLanguageContainer, clickedItem, languageInput);

            // **关键修复点：URL路径的清理和重构**
            const selectedLanguageCode = clickedItem.dataset.value.toLowerCase().substring(0, 2);
            let currentPathname = window.location.pathname;

            // 移除当前 URL 中的语言前缀（如果存在）
            const languagePathRegex = /^\/([a-z]{2}(-[a-z]{2})?)(\/|$)/i;
            currentPathname = currentPathname.replace(languagePathRegex, '');

            // 确保移除后路径以单个斜杠开头
            if (currentPathname.charAt(0) !== '/') {
                currentPathname = '/' + currentPathname;
            }

            // 构建新的 return_to 路径
            if (selectedLanguageCode !== 'en') {
                if (currentPathname === '/') {
                    returnToInput.value = '/' + selectedLanguageCode;
                } else {
                    returnToInput.value = '/' + selectedLanguageCode + currentPathname;
                }
            } else {
                returnToInput.value = currentPathname;
            }
        }
    });
    
    // 处理货币选项的选择
    currencySelector.addEventListener('click', (event) => {
    const clickedItem = event.target.closest('li');
    if (clickedItem) {
        // 更新下拉菜单中的选中状态和隐藏的输入框
        updateSelectedState(currencySelector, selectedCurrencyContainer, clickedItem, countryInput);
        
        // **关键修复：设置当前页面路径到 return_to 字段，避免跳回主页**
        let currentPathname = window.location.pathname;
        
        // 移除当前 URL 中的语言前缀（如果存在）
        const languagePathRegex = /^\/([a-z]{2}(-[a-z]{2})?)(\/|$)/i;
        currentPathname = currentPathname.replace(languagePathRegex, '');
        
        // 确保路径以单个斜杠开头
        if (currentPathname.charAt(0) !== '/') {
            currentPathname = '/' + currentPathname;
        }
        
        // 设置 return_to 为当前页面路径
        returnToInput.value = currentPathname;

        // **关键改动：获取被点击选项中的图片信息**
        const selectedImg = clickedItem.querySelector('.flag-icon');
        const selectedImgSrc = selectedImg.src;
        const selectedImgAlt = selectedImg.alt;

        // **更新顶部显示区域的国旗图片**
        const topCurrencyDisplay = document.querySelector('.selected-currency-container .flag-icon');
        if (topCurrencyDisplay) {
            topCurrencyDisplay.src = selectedImgSrc;
            topCurrencyDisplay.alt = selectedImgAlt;
        }
    }
});

    // 核心逻辑：点击 CHANGE 按钮时，直接提交表单
    const changeButton = localizationForm.querySelector('button[type="submit"]');
    changeButton.addEventListener('click', () => {
        localizationForm.submit();
    });
});

// 监听购物车内的礼物弹窗点击
document.addEventListener('click', function(e) {
  console.log(e.target.textContent,'标签文本')
  // 购物车容器
  const parentWrapper = e.target.closest('.gfgFreeGiftSideCartWrapperV4');
  if (parentWrapper) {
    // 查找弹窗内容元素
    const accordionContent = parentWrapper.querySelector('.gfgFreeGiftMsgContainerForAccordion')
    
    if (accordionContent) {
      // 检查当前状态并切换显示/隐藏
      const currentDisplay = getComputedStyle(accordionContent).display;
      
      if (currentDisplay === 'none' && e.target.closest('.gfgFreeGiftSelectDiv')) {
        // 显示弹窗
        accordionContent.style.display = 'block';
        parentWrapper.querySelector('.gfgFreeGiftDropDownButtonImageEle').style.transform = 'rotate(180deg)';
      } else if(currentDisplay === 'block' && (e.target.textContent == 'CLAIM' || e.target.closest('.gfgFreeGiftSelectDiv'))) {
        // 隐藏弹窗
        accordionContent.style.display = 'none';
        parentWrapper.querySelector('.gfgFreeGiftDropDownButtonImageEle').style.transform = 'rotate(0deg)';
      }
    }
  }
  // 产品页面
  const productWrapper = e.target.closest('.gfgFreeGiftWrapperV3');
  if (productWrapper) {
    // 通过父元素查找弹窗
    const accordionContent = productWrapper.querySelector('.gfgFreeGiftMsgContainerForAccordion')
    if (accordionContent) {
      // 检查当前状态并切换显示/隐藏
      const currentDisplay = getComputedStyle(accordionContent).display;
      
      if (currentDisplay === 'none'&& e.target.closest('.gfgFreeGiftSelectDiv')) {
        accordionContent.style.display = 'block';
        productWrapper.querySelector('.gfgFreeGiftDropDownButtonImageEle').style.transform = 'rotate(180deg)';
      }  else if(currentDisplay === 'block' && (e.target.textContent == 'CLAIM' || e.target.closest('.gfgFreeGiftSelectDiv'))) {
        accordionContent.style.display = 'none';
        productWrapper.querySelector('.gfgFreeGiftDropDownButtonImageEle').style.transform = 'rotate(0deg)';
      }
    }
  }
});